import {GuidesEnum, QueryParamsEnum} from 'presentation/constants';
import {GuideStep} from 'presentation/modules/guide/shared/constants/constants';
import {useMediaQueries} from 'presentation/pages/private';
import {useLocationStore} from 'presentation/pages/private/store/locationStore';
import {FlowType} from 'presentation/pages/private/store/locationStore/constants';
import {getUserInfoFromToken} from 'presentation/utils';
import {useNavigate} from 'react-router-dom';

export function useHealthGuideDistricts() {
	const navigate = useNavigate();
	const {isMobile} = useMediaQueries();

	const cdPessoaC = getUserInfoFromToken().cdPessoa;
	const getLocation = useLocationStore(state => state.getLocation);
	const selectedLocation = getLocation(cdPessoaC, FlowType.HEALTH_GUIDE);

	const {cdUf, nmUf} = selectedLocation.state;

	const pathCitySelection = `${GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_CITY}?${QueryParamsEnum.UF_CODE}=${cdUf}&${QueryParamsEnum.UF_NAME}=${nmUf}`;

	const handleClose = () => {
		navigate(
			`${GuidesEnum.SERVICE_NETWORK_HEALTH}?${QueryParamsEnum.STEP}=${GuideStep.LOCATION}`,
		);
	};

	const handleBack = () => {
		navigate(pathCitySelection);
	};

	return {
		isMobile,
		pathCitySelection,
		handleClose,
		handleBack,
	};
}
